import { useAppSelector } from 'features/app/hooks';
import { useSpawnParticipantCall } from 'features/call/call-accepted/hooks';
import { isDeafToHearingSelector } from 'features/call/call-base/store/selectors';
import { NewCall } from 'features/call/call-details/components';
import { callErrorSelector } from 'features/call/call-hearing/store';
import { isCallInitiatorPhoneNumberSelector } from 'features/call/call-status/store';
import { useDialedNumbersHistory } from 'features/dialed-numbers-history/hooks';
import { useValidatePhoneNumberInput } from 'features/phone-number/hooks';

export const NewCallContainer = () => {
  const isCallInitiatorPhoneNumber = useAppSelector(
    isCallInitiatorPhoneNumberSelector
  );
  const { isOpenHistory, setIsOpenHistory, dialedNumbersList } =
    useDialedNumbersHistory({ isExcluded: isCallInitiatorPhoneNumber });

  const { handleSpawnNewCall } = useSpawnParticipantCall();
  const isDeafToHearing = useAppSelector(isDeafToHearingSelector);

  const {
    ref,
    isPhoneNumberValid,
    setValue: setPhoneNumber,
    unmaskedValue,
  } = useValidatePhoneNumberInput();

  const callError = useAppSelector(callErrorSelector);

  return (
    <NewCall
      refPhoneNumber={ref}
      isPhoneNumberValid={isPhoneNumberValid}
      onSetPhoneNumber={setPhoneNumber}
      dialedNumbersList={dialedNumbersList}
      isOpenHistory={isOpenHistory}
      onOpenHistory={() => setIsOpenHistory(!isOpenHistory)}
      onHearingSpawnNewCall={(phoneExtension) =>
        handleSpawnNewCall(unmaskedValue, phoneExtension)
      }
      callError={callError}
      showExtensionInput={isDeafToHearing}
    ></NewCall>
  );
};
